import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo.jpg';

const Footer = () => {
  return (
    <footer className="bg-white py-16 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center space-x-2">
              <img src={logo} alt="Logo Nam Kiến Văn" className="h-10 w-auto" />
              <span className="text-base font-semibold text-gray-700 bg-gray-100 px-3 py-1 rounded-md">
                Nam Kiến Văn Education
              </span>
            </Link>

            <div className="space-y-3 text-sm text-gray-600">
              <p>
                Khi có thắc mắc hoặc khiếu nại về chất lượng dịch vụ, vui lòng liên hệ:
              </p>
              <p>
                <strong>Hotline:</strong> 0907065679
              </p>
              <p>
                <strong>Email:</strong> phungminhtam040667@gmail.com
              </p>
              <p className="mt-4">
                214B/5 - Nguyễn Trãi - Phường Nguyễn Cư Trinh - Quận 1
              </p>
            </div>
            
          </div>

          {/* Website Links */}
          <div>
            <h3 className="font-bold text-gray-900 mb-4">Về Website</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><a href="#" className="hover:text-primary-600">Giới thiệu</a></li>
              <li><a href="#" className="hover:text-primary-600">Học sinh tiêu biểu</a></li>
              <li><a href="tin-tuc" className="hover:text-primary-600">Bản tin Nam Kiến Văn</a></li>
              <li><a href="#" className="hover:text-primary-600">Liên hệ</a></li>
              
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h3 className="font-bold text-gray-900 mb-4">Chính Sách & Hỗ Trợ</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><a href="#" className="hover:text-primary-600">Chính sách & quy định chung</a></li>
              <li><a href="#" className="hover:text-primary-600">Chính sách bảo mật</a></li>
              <li><a href="#" className="hover:text-primary-600">Điều khoản sử dụng</a></li>
              <li><a href="#" className="hover:text-primary-600">Giải đáp thắc mắc</a></li>
            </ul>
          </div>

          {/* Study Programs */}
          <div>
            <h3 className="font-bold text-gray-900 mb-4">Chương Trình Học Tiêu Biểu</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              
              <li><a href="#" className="hover:text-primary-600">Học toán online lớp 7</a></li>
              <li><a href="#" className="hover:text-primary-600">Học toán online lớp 8</a></li>
              <li><a href="#" className="hover:text-primary-600">Học toán online lớp 9</a></li>
              <li><a href="#" className="hover:text-primary-600">Học toán online lớp 10</a></li>
              
              <li><a href="#" className="hover:text-primary-600">Học online lớp 11</a></li>
              <li><a href="#" className="hover:text-primary-600">Học online lớp 12</a></li>
            </ul>
          </div>
        </div>

        {/* Address */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="text-sm text-gray-600 space-y-2">
            <p>
              <strong>Văn phòng đại diện:</strong> 214B/5 - Nguyễn Trãi - Phường Nguyễn Cư Trinh - Quận 1
            </p>
            <p>
              <strong>Trụ sở chính HCM:</strong> 214B/5 - Nguyễn Trãi - Phường Nguyễn Cư Trinh - Quận 1
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-gray-200 text-center">
          <p className="text-sm text-gray-500">
            © 2025 Nam Kien Van Education. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
